// action types
import { createRequestTypes } from "../../utils";

export const FETCH_TAGS = createRequestTypes("FETCH_TAGS");

export const fetchTagsRequest = () =>
    ({ type: FETCH_TAGS.REQUEST });

export const fetchTagsSuccess = (tags) =>
    ({ type: FETCH_TAGS.SUCCESS, payload: tags });

export const fetchTagsFailure = (error) =>
    ({ type: FETCH_TAGS.FAILURE, payload: error });